export default {
  USER_OPTIONS(state, payload) {
    state.userOptions = payload
  },

  GET_ROOM_INFORMATION(state, payload) {
    state.currentRoom = payload
  },

  RESET_ROOM_INFORMATION(state) {
    state.currentRoom = null
  },

  RESET_LOGO_BRAND(state) {
    ;(state.customBrand = null), (state.loadingCustomBrand = false), (state.loadingCustomBrandFirstLoad = true)
  },

  SET_USER_TOKEN_INFORMATION(state, payload) {
    state.user = payload
  },

  SET_USER_ACCOUNT_INFORMATION(state, payload) {
    state.userAccount = payload
  },

  ADD_VIDEO(state, payload) {
    state.video = payload
    state.loading = false
  },

  ADD_SHOOTING(state, payload) {
    state.shooting = payload
    state.loading = false
  },

  ADD_SHOOTINGS(state, payload) {
    state.shootings = [...state.shootings, ...payload]
  },

  CHANGE_DEVICE_ID(state, payload) {
    const { kind, deviceId } = payload
    state = { ...(state.roomDevices[kind] = deviceId) }
  },

  GET_ROOM_INFORMATION(state, payload) {
    state.currentRoom = payload
  },

  GET_SHOOTINGS(state, payload) {
    state.shootings = payload
    state.loading = false
  },

  GET_SHOOTING_INFORMATION(state, payload) {
    state.shootingInformation = payload
  },

  GET_STAMPS(state, payload) {
    state.stamps = payload
  },

  GET_PRODUCTS(state, payload) {
    state.products = payload
    state.loading = false
  },

  GET_LABEL_OWNER(state, payload) {
    state.labelsOwner = payload
    state.loading = false
  },
  GET_ROOMS(state, payload) {
    state.rooms = payload
  },

  RESET_REGISTRATION(state) {
    state.newShooting.registration = ''
  },

  RESET_RESEARCH(state) {
    state.researchShooting.current = {
      registration: '',
      startDate: null,
      endDate: null,
      types: ['STANDARD', 'VIDEO', 'INSPECTION', 'INSPECTION_REPAIR_ORDER']
    }
  },

  RESET_ADD_SHOOTING_FORM(state) {
    state.newShooting = {
      status: 'create',
      registration: '',
      format: '',
      owner: '',
      stamp: null,
      shooting: []
    }
  },

  RESET_VIDEO(state) {
    state.video = {
      url: null
    }
  },

  RESEARCH_REGISTRATION(state, payload) {
    state.researchShooting.current.registration = payload
  },

  RESEARCH_TYPES(state, payload) {
    state.researchShooting.current.types = payload
  },

  RESEARCH_STARTDATE(state, payload) {
    state.researchShooting.current.startDate = payload
  },

  RESEARCH_ENDDATE(state, payload) {
    state.researchShooting.current.endDate = payload
  },

  RESET_ROOM_INFORMATION(state) {
    state.currentRoom = null
  },

  RESET_SHOOTING(state) {
    state.shooting = []
  },

  SET_OWNERS(state, payload) {
    state.owners = payload
  },

  SET_USER_TOKEN_INFORMATION(state, payload) {
    state.user = payload
  },

  SET_USER_ACCOUNT_INFORMATION(state, payload) {
    state.userAccount = payload
  },

  SET_SNACKBAR(state, payload) {
    const { snack, color } = payload
    state.snackbar.snack = snack
    state.snackbar.color = color
  },

  SAVE_PREV_CALL_SEARCH(state) {
    state.researchShooting.prev = Object.assign({}, state.researchShooting.current)
  },

  TOGGLE_LOADING(state, payload) {
    state.loading = payload
  },

  TOGGLE_LOADING_SEND_ADMIN_VIDEO_MEDIA(state, payload) {
    state.adminVideo.uploadLoading = payload
  },

  TOGGLE_LOADING_CUSTOM_BRAND(state, payload) {
    state.loadingCustomBrand = payload
  },

  TOGGLE_LOADING_CUSTOM_BRAND_FIRST_LOAD(state) {
    state.loadingCustomBrandFirstLoad = false
  },

  CUSTOM_BRAND_LOGO(state, payload) {
    state.customBrand = payload
  },

  CONTACT_INFORMATIONS(state, payload) {
    state.contactInformations = payload
  },

  TOGGLE_DEVICE(state, payload) {
    const { kind, status } = payload
    state.activeDevices[kind] = status
  },

  UPDATE_NEW_SHOOTING_STATUS(state, payload) {
    state.newShooting.status = payload
  },

  UPDATE_REGISTRATION(state, payload) {
    state.newShooting.registration = payload
  },

  UPDATE_STAMP(state, payload) {
    state.newShooting.stamp = payload
  },

  UPDATE_OWNER(state, payload) {
    state.newShooting.owner = payload
  },

  UPDATE_KEYCLOAK(state, payload) {
    state.keycloak = payload
  },

  UPDATE_NEW_SHOOTING(state, payload) {
    state.newShooting.shooting = payload
  },

  UPDATE_FORMAT(state, payload) {
    state.newShooting.format = payload
  },
  UPDATE_SHOOTING_EDITION_MODE(state, payload) {
    state.editShooting = payload
  },
  UPDATE_SELECTED_IMAGES(state, payload) {
    const { type, value } = payload

    if (type === 'push') {
      state.editShooting.selectedImages.push(value)
    } else if (type === 'splice') {
      const i = state.editShooting.selectedImages.indexOf(value)
      state.editShooting.selectedImages.splice(i, 1)
    }
  },

  UPDATE_STAMPS(state, payload) {
    state.stamps = payload
  },

  ADD_SHOOTING_USER_INFORMATION(state, payload) {
    state.shootingUserInformation = payload
  },

  ADD_SHOOTING_STATUS(state, payload) {
    state.shootingStatus = payload
  },

  ADD_STAMPS(state, payload) {
    state.shooting.stamps = payload
  },
  ADD_SHOOTING_CREATION_DATE(state, payload) {
    state.shootingCreationDate = payload
  }
}
